import React from "react";
import Dashboard from "./components/Dashboard";
import Stores from "./components/stores/Stores";
import Services from "./components/services/Services";
import Product from "./components/product/Product";
import Operators from "./components/operators/Operators";
// import Booking from "./components/booking/Booking";
import Customer from "./components/customer/Customer";
import Pos from "./components/pos/Pos";
import Orders from "./components/orders/Orders";
import MemberCards from "./components/membercards/MemberCards";
import Cards from "./components/cards/Cards"
import ReportDaily from "./components/report/ReportDaily"
import ReportLocation from "./components/report/ReportLocations";
import ReportCashier from "./components/report/ReportCashier"
import ReportUser from "./components/report/ReportUser";
import ReportProduct from "./components/report/ReportProduct";

import LeadWebsite from "./components/lead-website";
import Voucher from "./components/voucher";
import Emulation from "./components/emulation";

import ReportSales from "./components/report/ReportSales";
import ReportTvOnline from "./components/report/ReportTvOnline";
import ReportLtOnline from "./components/report/ReportLtOnline";
import ReportKtvTvvOffline from "./components/report/ReportKtvTvvOffline";
import ReportServiceDetail from "./components/report/ReportServiceDetail";
import ReportHeadOffice from "./components/report/ReportHeadOffice";
import IncomeFunction from "./components/report/Receipt"
import PromotionLocation from "./components/report/Promotion"
import DetailPromotion from "./components/report/DetailPromotion"
import UpdateVoucher from "./components/voucher/Update"
import Protected from "./middleware/authorize";
import TakeVoucher from "./components/TakeVoucher"
import GroupVoucher from "./components/voucher/GroupVoucher"
import SkinVoucher from "./components/voucher/SkinVoucher"
import Strapi from "./components/Strapi"  
import ReportByDay from "./components/report-by-day/Index";
import DetailQrCode from "./components/report/DetailQrCode"
import ReportOrderMisa from "./components/report/ReportOrderMisa"
import ReportRating from "./components/report/rating/ReportRating"
import ListDataSaleOnline from "./components/data-sale-online/ListDataSaleOnline";
import ListDataSaleOnlineV2 from "./components/data-sale-online-v2/ListDataSaleOnline";
import UpdateEmulation from "./components/emulation/Update"

import ReportOperateBooking from "./components/report/more/ReportOperateBooking"
import ReportBusiness from "./components/report/more/ReportBusiness"
import ReportKtvTvDetails from "./components/report/more/ReportKtvTvDetails" // tổng thế nhân viên
import ReportKtvTvvDetail from "./components/report/more/ReportKtvTvvDetail" // chi từng nhân viên
import ReportStoreBooingPrice from "./components/report/more/ReportStoreBooingPrice" // chi từng nhân viên
import ReportBusinessCustomer from "./components/report/more/ReportBusinessCustomer"
import ReportUpsale from "./components/report/more/ReportUpsale"
import ReportExpectedCash from "./components/report/more/ReportExpectedCash"
import ReportDebtCollection from "./components/report/more/ReportDebtCollection"
import ReportPurchaseBehavior from "./components/report/more/ReportPurchaseBehavior"
import ReportSaleTvCtm from "./components/report/sale-online/ReportSaleTvCtm" // chi từng nhân viên
import ReportEmulation from "./components/report/ReportEmulation" // List thi đua
import ReportCustomerBusiness from "./components/report/ReportCustomerBusiness" // kinh doanh dịch vụ phễu
import ReportServiceChuaThucHien from "./components/report/ReportServiceChuaThucHien" // kinh doanh dịch vụ phễu
import ReportCashFlow from "./components/report/franchise/ReportCashFlow" // Dòng tiền
import ReportBHVV from "./components/report/franchise/ReportBHVV" // Dòng tiền
import ReportPhucVuCheo from "./components/report/franchise/ReportPhucVuCheo";
// import ReportByKTV from "./components/report-by-day/ReportByKTV";
import Independence from "./components/report/pillar/Independence";
import Freedom from "./components/report/pillar/Freedom";
import Happiness from "./components/report/pillar/Happiness";

import PagePancake from "./components/pancake/PagePancake";


const routes = [
  {
    path: "/dashboard",
    exact: false,
    main: () => <Dashboard />,
  },
  {
    path: "/take-voucher",
    exact: false,
    main: () => <Protected permissions={[1,3,5]} >
      <TakeVoucher />
    </Protected >,
  },
  {
    path: "/create-voucher-lv3",
    exact: false,
    main: () => <Protected permissions={[1,3,5]} >
      <GroupVoucher />
    </Protected >,
  },
  {
    path: "/create-voucher-skin",
    exact: false,
    main: () => <Protected permissions={[1,3,5]} >
      <SkinVoucher />
    </Protected >,
  },
  {
    path: "/receipt",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <IncomeFunction />
    </Protected >,
  },
  {
    path: "/stores",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <Stores />
    </Protected >,
  },
  {
    path: "/services",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <Services />
    </Protected >,
  },
  {
    path: "/operators",
    exact: false,
    main: () => <Protected permissions={[1]} >
        <Operators />
    </Protected >,
  },
  // {
  //   path: "/booking",
  //   exact: true,
  //   main: () => <Booking />,
  // },
  {
    path: "/customer",
    exact: false,
    main: () => <Customer />,
  },
  {
    path: "/pos",
    exact: true,
    main: () => <Protected permissions={[1,3, 5]} >
        <Pos />
    </Protected >,
  },
  {
    path: "/orders",
    exact: true,
    main: () => <Orders />,
  },
  {
    path: "/membercards",
    exact: true,
    main: () => <Protected permissions={[1, 5]} >
        <MemberCards />
    </Protected >,
  },
  {
    path: "/cards",
    exact: true,
    main: () => <Protected permissions={[1, 5]} >
      <Cards />
    </Protected >,
  },
  {
    path: "/vouchers",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <Voucher />
    </Protected >,
  },
  {
    path: "/voucher/:id",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <UpdateVoucher />
    </Protected >,
  },
  {
    path: "/lead-website",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <LeadWebsite />
    </Protected >,

  },
  {
    path: "/product",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <Product />
    </Protected >,
  },
  {
    path: "/strapi",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <Strapi />
    </Protected >,

  },
  {
    path: "/report-by-day",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <ReportByDay />
    </Protected >,
  },
  {
    path: "/data/sale-online",
    exact: false,
    main: () => <ListDataSaleOnline />,
  },
    {
    path: "/data/sale-online-v2",
    exact: false,
    main: () => <ListDataSaleOnlineV2 />,
  },
  {
    path: "/emulation",
    exact: true,
    main: () => <Protected permissions={[1]} >
      <Emulation />
    </Protected >,
  },
  {
    path: "/emulation/:id",
    exact: true,
    main: () => <Protected permissions={[1]} >
      <UpdateEmulation />
    </Protected >,
  },
  {
    path: "/report/daily",
    exact: false,
    main: () => <ReportDaily />,
  },
  {
    path: "/report/locations",
    exact: false,
    main: () => <Protected permissions={[1,8]}>
      <ReportLocation />
    </Protected>,
  },
  {
    path: "/report/cashiers",
    exact: false,
    main: () => <ReportCashier />,
  },
  {
    path: "/report/users",
    exact: false,
    main: () => <ReportUser />,
  },
  {
    path: "/report/products",
    exact: false,
    main: () => <ReportProduct />,
  },
  {
    path: "/report/sales",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <ReportSales />
    </Protected >,

  },
  {
    path: "/report/promotion",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <PromotionLocation />
    </Protected >,
  },

  {
    path: "/report/detail-promotion",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <DetailPromotion />
    </Protected >,
  },
  {
    path: "/report/qr-code",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <DetailQrCode />
    </Protected >,
  },
  {
    path: "/report/online",
    exact: false,
    main: () => <Protected permissions={[1,8]}>
      <ReportTvOnline />
    </Protected >,
  },

  {
    path: "/report/offline-lt",
    exact: false,
    main: () => <Protected permissions={[1,8]}>
      <ReportLtOnline />
    </Protected >,
  },
  {
    path: "/report/offline-ktv-tvv",
    exact: false,
    main: () => <Protected permissions={[1,8]}>
      <ReportKtvTvvOffline />
    </Protected >,
  },
  {
    path: "/report/service-detail",
    exact: false,
    main: () => <ReportServiceDetail />,
  },
  {
    path: "/report/operate-booking",
    exact: false,
    main: () => <ReportOperateBooking />,
  },
  {
    path: "/report/business",
    exact: false,
    main: () => <ReportBusiness />,
  },
  {
    path: "/report/customer-course",
    exact: false,
    main: () => <ReportBusinessCustomer kind="course" />,
  },
  {
    path: "/report/customer-new",
    exact: false,
    main: () => <ReportBusinessCustomer kind="new" />,
  },
  {
    path: "/report/upsale",
    exact: false,
    main: () => <ReportUpsale />,
  },
  {
    path: "/report/expected-cash",
    exact: false,
    main: () => <ReportExpectedCash />,
  },
  {
    path: "/report/debt-collection",
    exact: false,
    main: () => <ReportDebtCollection />,
  },
  {
    path: "/report/purchase-behavior",
    exact: false,
    main: () => <ReportPurchaseBehavior />,
  },
  {
    path: "/report/ktv-tv-details",
    exact: false,
    main: () => <ReportKtvTvDetails />,
  },
  {
    path: "/report/ktv-tvv-detail",
    exact: false,
    main: () => <ReportKtvTvvDetail />,
  },
  {
    path: "/report/total-price-booking",
    exact: false,
    main: () => <ReportStoreBooingPrice />,
  },

  {
    path: "/report/detail/sale-ctm",
    exact: false,
    main: () => <Protected permissions={[1, 5, 8]} >
      <ReportSaleTvCtm />
    </Protected >,
  },
  {
    path: "/report/emulation",
    exact: false,
    main: () => <ReportEmulation />,
  },
  {
    path: "/report/hopper",
    exact: false,
    main: () => <ReportCustomerBusiness />,
  },

  {
    path: "/report/service-chua-thuc-hien",
    exact: false,
    main: () => <Protected permissions={[1]} >
      <ReportServiceChuaThucHien />
    </Protected >,
  },
  {
    path: "/report/customer-paid-store",
    exact: false,
    main: () => <ReportCashFlow />,
  },
  {
    path: "/report/service-do-housework",
    exact: false,
    main: () => <ReportPhucVuCheo />,
  },

  {
    path: "/report/bhvv-flow",
    exact: false,
    main: () => <ReportBHVV />,
  },

  {
    path: "/report/order-misa",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <ReportOrderMisa />
    </Protected >,
  },
  {
    path: "/report/independence",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <Independence />
    </Protected >,
  },

  {
    path: "/report/happiness",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <Happiness />
    </Protected >,
  },
  {
    path: "/report/freedom",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <Freedom />
    </Protected >,
  },
  {
    path: "/report/head-office",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <ReportHeadOffice />
    </Protected >,
  },
  {
    path: "/report/rating",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <ReportRating />
    </Protected >,
  },
  {
    path: "/page-pancake",
    exact: false,
    main: () => <Protected permissions={[1]}>
      <PagePancake />
    </Protected >,
  },
];

export default routes;
